import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';
import { StyledStatusPill } from '@/modules/Conversations/components';

export const StyledContainer = styled.div`
  padding: 1.5rem;
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
  align-items: start;

  @media screen and ${DEVICES.LAPTOP_S} {
    grid-template-columns: minmax(0, 1.5fr) minmax(0, 1fr);
  }
`;

export const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  min-width: 0;
`;

export const StyledSubtitle = styled.div`
  ${pickThemeFontStyles('13', '18')}
  color: ${COLORS.TEXT_HINT};
`;

export const StyledTitlePill = styled(StyledStatusPill)`
  margin-left: 0.75rem;
  vertical-align: middle;
  text-transform: none;
`;

export const StyledLoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
`;
